import clsx from 'clsx';
import React, { useState } from 'react';

import RelatedStories from '@components/RelatedStories';

import { InsightArticle } from '.';

enum Topic {
  Tech = 'Tech',
  Finance = 'Finance',
  Ecommerce = 'E-commerce',
  Media = 'Media',
  ElectricVehicles = 'Electric Vehicles',
}

interface InsightProps {
  insightArticlesByTopic: InsightArticle[];
}

const Insight = ({ insightArticlesByTopic }: InsightProps) => {
  const [currentTopic, setCurrentTopic] = useState<Topic>(Topic.Tech);
  const currentArticles =
    insightArticlesByTopic.find(
      (article) => article.topic.toLowerCase() === currentTopic.toLowerCase()
    )?.articles || [];

  return (
    <>
      <h1 className="m-0 mb-48 text-center font-suisse-works text-headline-sm sm:text-headline-lg lg:text-headline-xl">
        <span className="font-bold text-primary-magenta">Unmatched</span> Insights from Asia and the
        U.S.
      </h1>
      <div className="flex w-full items-start justify-center gap-[23px] sm:gap-48 md:gap-64 lg:gap-80">
        {Object.values(Topic).map((topic, index) => (
          <div
            className={clsx(
              'relative w-min cursor-pointer self-end font-suisse-intl-mono text-overline-sm hover:text-primary-magenta xs:text-caption-md sm:w-auto lg:text-caption-lg dark:hover:text-primary-pink',
              {
                'text-primary-magenta': currentTopic === topic,
                'whitespace-pre': topic === Topic.Ecommerce,
              }
            )}
            key={index}
            onClick={() => setCurrentTopic(topic)}
          >
            <div className="rtl pb-12 text-left [unicode-bidi:plaintext]">{topic}</div>
            {currentTopic === topic && (
              <div className="absolute bottom-0 left-4 right-4 h-12 bg-primary-magenta" />
            )}
          </div>
        ))}
      </div>
      <RelatedStories
        articles={currentArticles}
        className="border-b-2 border-grayscale-gray border-b-grayscale-charcoal px-32 !pb-96 !pt-48"
        gridClassName="xs:!gap-32"
        headline=""
        skipBlueConicRecommendations
      />
    </>
  );
};

export default Insight;
